import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  GetLabelsError,
  GetLabelsSuccess,
  GetOndemandLangLabels,
  GetOndemandLangLabelsSuccess,
} from './labels.actions';
import { EnvService } from '../../services/env.service';
import { supportedLocale } from '../../config/app-config';
import { SetSearchParams } from '../query-params';
import { ClearCountriesDataAction } from '../countries/countries.actions';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class LabelsEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private envService: EnvService,
    private store: Store,
    private cookieService: CookieService
  ) {}

  public getLabels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetSearchParams),
      mergeMap((prepareData: any) => {
        let locale = prepareData?.queryParams?.queryParams?.locale || 'en-US';
        locale =
          locale.length !== 5 ? this.convertTwoCharacterLocale(locale) : locale;
        const lang = locale.substring(0, 2) || 'en';
        const country = locale.substring(3, 5) || 'US';
        const labelFileName = `STELLAR-${lang.toUpperCase()}.json`;
        const url = `${this.envService.cmsUrl}/${country}/${labelFileName}`;
        return this.http.get(url).pipe(
          map((data: any) => {
            this.store.dispatch(ClearCountriesDataAction());
            this.cookieService.set('langCode', locale);
            return GetLabelsSuccess({
              getLabelsResponse: {
                state: data,
                id: 'common',
                operation: prepareData?.queryParams?.queryParams?.operation,
              },
              endpoint: prepareData?.endpoint,
            });
          }),
          catchError((error) => {
            return of(GetLabelsError(error));
          })
        );
      })
    )
  );

  private convertTwoCharacterLocale(localeStr: string): string {
    return (
      supportedLocale.find(
        (loc) => loc.substring(0, 2) === localeStr.substring(0, 2)
      ) || 'en-US'
    );
  }

  public getLangLabels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetOndemandLangLabels),
      mergeMap(({ getLabelsRequest }) => {
        const lang = getLabelsRequest?.locale.substring(0, 2) || 'en';
        const country = getLabelsRequest?.locale.substring(3, 5) || 'US';
        const labelFileName = `STELLAR-${lang.toUpperCase()}.json`;
        const url = `${this.envService.cmsUrl}/${country}/${labelFileName}`;
        return this.http.get(url).pipe(
          map((data: any) => {
            this.store.dispatch(ClearCountriesDataAction());
            this.cookieService.set('langCode', `${lang}-${country}`);
            return GetOndemandLangLabelsSuccess({
              getLabelsResponse: {
                state: data,
                id: 'common',
                operation: 'deposit',
                lang,
              },
            });
          }),
          catchError((error) => {
            return of(GetLabelsError(error));
          })
        );
      })
    )
  );
}
